import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/(private)/requesters/$id/')({
  component: RequesterDetails,
});

function RequesterDetails() {
  return <div>Hello "/_layout/(private)/requesters/$id/"!</div>;
}
